/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { list2 } from '~/actions/containers';
import { Button } from 'react-toolbox/lib/button';
import Container from '~/components/Container';
import Spinner from '~/components/Spinner';
import LocationPicker from '~/components/LocationPicker';
import OrderPicker from '~/components/OrderPicker';

import style from './style.scss';

const components = {
  orderId: {
    label: 'Order',
    component: OrderPicker,
    required: false
  },
  locationId: {
    label: 'Location',
    component: LocationPicker,
    required: false
  },
};

class Containers extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
      query: '',
      ids: {
        orderId: '',
        locationId: '',
      }
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.ids,
    )
      .then(r => {
        this.setState({
          results: r.data.results.map(i => i.id),
          skipId: r.data.skipId,
          more: r.data.more,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  loadMore() {
    this.setState({ loading: true });
    list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.ids,
      this.state.skipId,
    )
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results.map(i => i.id)],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title}>Containers</div>
        <Button
          label="New Container"
          onClick={() => this.context.dialogPush('containerNew', { onCreate: () => this.search() })}
          raised
          primary
          className={style.buttonNew}
          icon="add"
        />
        <form onSubmit={e => { e.preventDefault(); this.setState({ skipId: null }); this.search(); }} style={{ marginBottom: '10px' }}>
          <input
            placeholder="Search SKU, TYPE and ID"
            className={style.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <div className={style.filters}>
            <b>Filters</b>
            {Object.keys(components).map(key => {
              const Cmp = components[key].component;
              const field = components[key];
              return (
                <div className={style.filter} key={`component_${key}`}>
                  <div className={style.label}>{components[key].label}</div>
                  <div className={style.item}>
                    {Cmp ? <Cmp
                      key={field.label}
                      id={field.label}
                      value={this.state.ids[key]}
                      required={field.required}
                      onChange={v => this.setState({ ids: { ...this.state.ids, [key]: v } })}
                    /> : `Unknown field type "${field.type}"`
                    }
                  </div>
                </div>
              );
            })}
          </div>
          <Button label="Find" primary raised type="submit" />
        </form>
        {this.state.results.map(id => <Container id={id} key={id} style={{ margin: '0 10px 10px 0' }} />)}
        {this.state.loading && <div><Spinner className={style.spinner} /></div>}
        {!this.state.loading && <div style={{ paddingTop: '10px' }}>
          {this.state.results.length === 0 && !this.state.loading && <div>No results found</div>}
          {!this.state.loading && this.state.more && <Button
            label="Load more"
            disabled={this.state.loading}
            primary
            raised
            onClick={() => this.loadMore()}
            className={style.buttonLoadMore}
          />}
        </div>}
      </div>
    );
  }
}

export default connect()(Containers);



// WEBPACK FOOTER //
// ./app/pages/Containers/index.js